/* eslint-disable class-methods-use-this */
import Model from './Model';
import FrameworkCategories from '../data/FrameworkCategories';

export default class AssessmentQuestion extends Model {
    // noinspection JSMethodCanBeStatic
    resource() {
        return 'assessment_questions';
    }

    async getFrameworkCategory() {
        return FrameworkCategories.findResource(this.frameworkCategory);
    }
}
